module.exports = __webpack_public_path__ + "img/ABC-COVER.ad11487d.png";